<script lang="ts">
  import Layout from "../../components/layout/Layout.svelte";

  let { user = null, reason = "not_found" as const }: {
    user?: { id: string; name: string; email: string; avatarUrl?: string } | null;
    reason?: "not_found" | "expired" | "already_used" | "revoked";
  } = $props();

  const messages: Record<string, { icon: string; title: string; description: string }> = {
    not_found: {
      icon: `<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />`,
      title: "초대를 찾을 수 없습니다",
      description: "유효하지 않은 초대 링크예요. 방장에게 새 링크를 요청해 주세요.",
    },
    expired: {
      icon: `<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />`,
      title: "초대가 만료되었습니다",
      description: "이 초대 링크는 유효 기간이 지났어요. 방장에게 새 링크를 요청해 주세요.",
    },
    already_used: {
      icon: `<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />`,
      title: "이미 사용된 초대입니다",
      description: "이 초대 링크는 이미 사용되었습니다. 여행 페이지에서 확인해보세요.",
    },
    revoked: {
      icon: `<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636" />`,
      title: "취소된 초대입니다",
      description: "이 초대는 주최자에 의해 취소되었습니다.",
    },
  };

  let message = $derived(messages[reason] || messages.not_found);
</script>

<Layout {user}>
  <div class="min-h-screen bg-app flex items-center justify-center p-4">
    <div class="w-full max-w-md">
      <div class="bg-surface rounded-2xl shadow-xl p-8 text-center">
        <!-- Icon -->
        <div class="w-20 h-20 mx-auto bg-surface-hover rounded-full flex items-center justify-center mb-6">
          <svg class="w-10 h-10 text-muted" fill="none" stroke="currentColor" viewBox="0 0 24 24">{@html message.icon}</svg>
        </div>

        <!-- Message -->
        <h1 class="text-2xl font-bold text-primary mb-3">{message.title}</h1>
        <p class="text-muted mb-8 [word-break:keep-all] [overflow-wrap:break-word]">{message.description}</p>

        <!-- Actions -->
        <div class="space-y-3">
          {#if reason === "already_used" && user}
            <a
              href="/trips"
              class="block w-full py-3 bg-gradient-to-r from-blue-600 to-cyan-500 text-white rounded-xl font-medium hover:shadow-lg transition-all"
            >
              내 여행 보기
            </a>
          {:else}
            <a
              href="/"
              class="block w-full py-3 bg-gradient-to-r from-blue-600 to-cyan-500 text-white rounded-xl font-medium hover:shadow-lg transition-all"
            >
              홈으로 돌아가기
            </a>
          {/if}

          {#if !user}
            <p class="text-sm text-muted">
              계정이 있으신가요? <a href="/login" class="text-blue-600 hover:underline">로그인</a>
            </p>
          {/if}
        </div>

        <!-- Help -->
        <div class="mt-8 pt-6 border-t border">
          <p class="text-sm text-muted">
            문제가 계속되면 <a href="/help" class="text-blue-500 hover:underline">고객센터</a>에 문의해주세요.
          </p>
        </div>
      </div>
    </div>
  </div>
</Layout>
